import { PrensaEngine } from '@xprog/prensa'

export const Input = PrensaEngine.styled('input', {})
export const Label = PrensaEngine.styled('label', {})